import React from 'react'
const SvgChoose1 = props => (
  <svg id='choose1_svg___\u56FE\u5C42_2' viewBox='0 0 631.7 201.48' {...props}>
    <defs>
      <style>
        {
          '.choose1_svg__cls-3,.choose1_svg__cls-4,.choose1_svg__cls-5{letter-spacing:.02em}.choose1_svg__cls-7{fill:#fd5c1f}.choose1_svg__cls-8{fill:#252a3a}.choose1_svg__cls-10,.choose1_svg__cls-4,.choose1_svg__cls-9{fill:#8796aa}.choose1_svg__cls-10,.choose1_svg__cls-4{font-size:12px;font-family:Roboto-Regular,Roboto}.choose1_svg__cls-16{letter-spacing:0}.choose1_svg__cls-17{letter-spacing:-.02em}'
        }
      </style>
    </defs>
    <g id='choose1_svg___\u56FE\u5C42_1-2'>
      <path
        className='choose1_svg__cls-7'
        d='M511.59 35.27v5.17c0 1.89 5.42 4.01 12.67 4.01s12.67-2.12 12.67-4.01v-5.17c-2.48 1.92-7.69 2.94-12.67 2.94s-10.19-1.02-12.67-2.94z'
      />
      <path
        className='choose1_svg__cls-7'
        d='M511.59 26.54v5.17c0 1.89 5.42 4.01 12.67 4.01s12.67-2.12 12.67-4.01v-5.17c-2.48 1.92-7.69 2.94-12.67 2.94s-10.19-1.02-12.67-2.94zM511.59 43.71v5.17c0 1.89 5.42 4.01 12.67 4.01s12.67-2.12 12.67-4.01v-5.17c-2.48 1.92-7.69 2.94-12.67 2.94s-10.19-1.02-12.67-2.94z'
      />
      <path
        className='choose1_svg__cls-7'
        d='M524.26 27c7.25 0 12.67-2.12 12.67-4.01s-5.42-4.01-12.67-4.01-12.67 2.12-12.67 4.01S517.01 27 524.26 27z'
      />
      <text className='choose1_svg__cls-10' transform='translate(0 15.97)'>
        <tspan className='choose1_svg__cls-3' x={0} y={0}>
          {'Security and '}
        </tspan>
        <tspan x={72.7} y={0} letterSpacing='.02em'>
          {'A'}
        </tspan>
        <tspan className='choose1_svg__cls-3' x={80.76} y={0}>
          {'udit'}
        </tspan>
        <tspan className='choose1_svg__cls-3'>
          <tspan x={28.52} y={16}>
            {'Management'}
          </tspan>
        </tspan>
      </text>
      <text className='choose1_svg__cls-4' transform='translate(76.59 68.13)'>
        <tspan x={0} y={0}>
          {'User'}
        </tspan>
        <tspan x={-48.07} y={16}>
          {'Management'}
        </tspan>
      </text>
      <text className='choose1_svg__cls-4' transform='translate(7.4 122.3)'>
        <tspan x={0} y={0}>
          {'Security Settings'}
        </tspan>
        <tspan x={21.12} y={16}>
          {'Management'}
        </tspan>
      </text>
      <text className='choose1_svg__cls-4' transform='translate(78.91 178.47)'>
        <tspan x={0} y={0}>
          {'Link'}
        </tspan>
        <tspan x={-50.39} y={16}>
          {'Management'}
        </tspan>
      </text>
      <text className='choose1_svg__cls-10' transform='translate(550.95 34.97)'>
        <tspan x={0} y={0}>
          {'Data S'}
        </tspan>
        <tspan className='choose1_svg__cls-16' x={34.93} y={0}>
          {'t'}
        </tspan>
        <tspan x={38.74} y={0}>
          {'o'}
        </tspan>
        <tspan className='choose1_svg__cls-17' x={45.58} y={0}>
          {'r'}
        </tspan>
        <tspan x={49.41} y={0}>
          {'age '}
        </tspan>
        <tspan x={0} y={16}>
          {'Management'}
        </tspan>
      </text>
      <text className='choose1_svg__cls-10' transform='translate(550.95 87.97)'>
        <tspan x={0} y={0}>
          {'R'}
        </tspan>
        <tspan x={7.39} y={0} letterSpacing={0}>
          {'a'}
        </tspan>
        <tspan x={13.83} y={0}>
          {'ysync Client '}
        </tspan>
        <tspan x={0} y={16} letterSpacing='-.04em'>
          {'T'}
        </tspan>
        <tspan className='choose1_svg__cls-17' x={6.72} y={16}>
          {'r'}
        </tspan>
        <tspan x={10.55} y={16}>
          {'ansmission '}
        </tspan>
        <tspan x={0} y={32}>
          {'Management'}
        </tspan>
      </text>
      <text className='choose1_svg__cls-10' transform='translate(550.95 161.97)'>
        <tspan x={0} y={0} letterSpacing={0}>
          {'P'}
        </tspan>
        <tspan x={7.49} y={0}>
          {'ersonali'}
        </tspan>
        <tspan x={49.92} y={0} letterSpacing={0}>
          {'z'}
        </tspan>
        <tspan x={55.77} y={0}>
          {'ed '}
        </tspan>
        <tspan x={0} y={16}>
          {'Cus'}
        </tspan>
        <tspan className='choose1_svg__cls-16' x={20.61} y={16}>
          {'t'}
        </tspan>
        <tspan x={24.42} y={16}>
          {'omization'}
        </tspan>
      </text>
      <path className='choose1_svg__cls-9' d='M433.92 39h62v-2h-62' />
      <path className='choose1_svg__cls-9' d='M495.49 43.43l7.97-6.04-8.03-5.96M221.92 19h-62v2h62' />
      <path className='choose1_svg__cls-9' d='M160.76 14.43l-7.97 6.04 8.03 5.96M221.92 73h-62v2h62' />
      <path className='choose1_svg__cls-9' d='M160.76 68.01l-7.97 6.04 8.03 5.96M221.92 126h-62v2h62' />
      <path className='choose1_svg__cls-9' d='M160.76 121.6l-7.97 6.04 8.03 5.96M221.92 180h-62v2h62' />
      <path className='choose1_svg__cls-9' d='M160.76 175.18l-7.97 6.04 8.03 5.96M433.92 98h62v-2h-62' />
      <path className='choose1_svg__cls-9' d='M495.49 103.18l7.97-6.04-8.03-5.96M433.92 164h62v-2h-62' />
      <path className='choose1_svg__cls-9' d='M495.49 169.18l7.97-6.04-8.03-5.96' />
      <g>
        <path
          className='choose1_svg__cls-7'
          d='M140.45 62.83l-11-6.18c-1.25-.7-3.13-.7-4.38 0l-11 6.18c-1.26.71-2.21 2.32-2.21 3.76v13.07c0 1.43.95 3.05 2.21 3.76l11.01 6.18c.61.34 1.39.53 2.18.53s1.57-.19 2.18-.53l11.01-6.19c1.26-.71 2.21-2.32 2.21-3.76V66.58c0-1.43-.95-3.05-2.21-3.76zm.21 16.83c0 .72-.56 1.66-1.19 2.01l-11.01 6.18c-.62.35-1.78.35-2.41 0l-11.01-6.18c-.63-.36-1.19-1.3-1.19-2.01V66.59c0-.72.56-1.66 1.19-2.01l11-6.18c.32-.18.76-.27 1.21-.27s.89.09 1.21.27l11 6.18c.63.36 1.19 1.3 1.19 2.01v13.07z'
        />
        <path
          className='choose1_svg__cls-7'
          d='M127.31 67.03c.08.05.18.07.28.07s.2-.03.28-.07l2.09-1.22c.19-.11.31-.31.31-.53v-2.43c0-.22-.12-.42-.31-.53l-2.07-1.21c-.16-.1-.43-.1-.6 0l-2.08 1.22c-.19.11-.3.31-.3.53v2.43c0 .22.12.42.31.53l2.09 1.22zM126.93 69.04v5c.13.3.37.55.67.55s.54-.25.67-.55v-5c-.13-.3-.37-.55-.67-.55s-.54.25-.67.55zM136.17 74c.09 0 .18-.02.27-.07a.55.55 0 00.2-.75c-.11-.2-1.65-3.21-6.1-5.73a.533.533 0 00-.73.21c-.14.27-.05.6.21.74 4.18 2.36 5.66 5.26 5.69 5.31.1.18.28.28.46.28zM124.66 67.45c-4.45 2.51-5.99 5.53-6.1 5.73-.15.26-.06.6.2.75a.535.535 0 00.73-.21c.02-.05 1.51-2.95 5.69-5.31.26-.15.35-.48.21-.74a.522.522 0 00-.73-.21zM134.96 75.72h4.02v4.02h-4.02zM125.59 75.72h4.02v4.02h-4.02zM116.21 75.72h4.02v4.02h-4.02z'
        />
      </g>
      <g>
        <path
          className='choose1_svg__cls-7'
          d='M118.7 8.56h9.9c.3 0 .49-.2.49-.5s-.2-.5-.4-.5h-9.9c-.3 0-.49.2-.49.5s.2.5.4.5z'
        />
        <path
          className='choose1_svg__cls-7'
          d='M132.01.56h-15.5c-1.95 0-3.25 1.69-3.25 3.76V30.8c0 2.07 1.3 3.76 3.25 3.76h20.95c1.95 0 3.8-1.69 3.8-3.76V9.75l-9.25-9.2zm.25 2.68l6.95 7.32h-5.09c-1.21 0-1.86-1.03-1.86-2.35V3.24zm7 27.41c0 1.05-1.08 1.91-2.06 1.91h-20.62c-.88 0-1.32-.84-1.32-1.86V4.42c0-1.03.53-1.86 1.32-1.86h13.68v6.65c0 1.82 1.18 3.35 2.94 3.35h6.06v18.09z'
        />
        <path
          className='choose1_svg__cls-7'
          d='M118.08 14.06c0 .3.2.5.49.5h16.99c.3 0 .49-.2.49-.5s-.3-.5-.49-.5h-16.99c-.3 0-.49.2-.49.5zM126.94 26.14c1.6-1.96 1.51-4.85-.32-6.68a5.003 5.003 0 00-7.07 0 5.003 5.003 0 000 7.07c1.83 1.83 4.72 1.92 6.68.32l1.8 1.8c.2.2.51.2.71 0s.2-.51 0-.71l-1.8-1.8zm-1.02-.32c-1.56 1.56-4.1 1.56-5.66 0s-1.56-4.1 0-5.66c1.56-1.56 4.1-1.56 5.66 0s1.56 4.1 0 5.66z'
        />
      </g>
      <g>
        <path
          className='choose1_svg__cls-7'
          d='M128.52 175.34l-1.1 1.11 3.31 3.31-3.31 3.32 1.1 1.11 4.43-4.43-4.43-4.42zM120.44 175.34l-4.42 4.42 4.42 4.43 1.11-1.11-3.32-3.32 3.32-3.31-1.11-1.11z'
        />
        <path
          className='choose1_svg__cls-7'
          transform='rotate(-69.44 124.483 179.83)'
          d='M119.8 179.05h9.38v1.56h-9.38z'
        />
        <path className='choose1_svg__cls-7' d='M112.26 167.48v34h11.96v-1.7h-10.24v-30.6h26.56v17h1.72v-18.7h-30z' />
        <path
          className='choose1_svg__cls-7'
          d='M141.26 194.3c.05-1.6-.52-3.13-1.62-4.3a6 6 0 00-4.18-1.9c-1.59-.05-3.13.52-4.3 1.62-2.41 2.26-2.54 6.07-.28 8.48a5.99 5.99 0 004.38 1.9c1.15 0 2.3-.34 3.3-1l2.23 2.38 1.46-1.37-2.23-2.38c.75-.98 1.18-2.17 1.23-3.43zm-3.26 2.72a3.998 3.998 0 01-5.46-5.84c.78-.73 1.8-1.1 2.87-1.08 1.07.04 2.06.48 2.79 1.26s1.11 1.8 1.08 2.87a3.989 3.989 0 01-1.26 2.79z'
        />
      </g>
      <text transform='translate(255.99 155.46)' fontSize={14} fontFamily='Roboto-Regular,Roboto' fill='#8796aa'>
        <tspan className='choose1_svg__cls-5' x={0} y={0}>
          {'R'}
        </tspan>
        <tspan x={8.97} y={0} letterSpacing='.02em'>
          {'a'}
        </tspan>
        <tspan className='choose1_svg__cls-5' x={16.83} y={0}>
          {'ysync Admin '}
        </tspan>
        <tspan x={103.91} y={0} letterSpacing='.02em'>
          {'P'}
        </tspan>
        <tspan className='choose1_svg__cls-5' x={113} y={0}>
          {'o'}
        </tspan>
        <tspan x={121.33} y={0} letterSpacing='.05em'>
          {'r'}
        </tspan>
        <tspan className='choose1_svg__cls-5' x={126.76} y={0}>
          {'tal'}
        </tspan>
      </text>
      <path
        className='choose1_svg__cls-9'
        d='M367.48 59.55l-82.92.04c-3.81 0-6.91 3.1-6.91 6.91l.02 46.68c0 3.81 3.1 6.91 6.91 6.91l36.8-.02-1.46 5.52h-9.49v1.98h31.24v-1.99h-9.49l-1.47-5.52 36.8-.02c3.81 0 6.91-3.1 6.91-6.91l-.02-46.68c0-3.81-3.1-6.91-6.91-6.91zm4.96 53.59c0 2.72-2.21 4.94-4.93 4.94l-82.92.04c-2.72 0-4.94-2.21-4.94-4.93l-.02-46.68c0-2.72 2.21-4.94 4.93-4.94l82.92-.04c2.72 0 4.94 2.21 4.94 4.93l.02 46.68z'
      />
      <path
        d='M348.71.5h85.33v200H221.92V.5h126.79'
        fill='none'
        stroke='#8796aa'
        strokeDasharray='0 0 4 4'
        strokeMiterlimit={10}
      />
      <g>
        <path
          className='choose1_svg__cls-7'
          d='M329.09 77.04c-3.49 0-6.97.67-10.04 1.42l2.27 1.63c-3.06.58-6.19.4-7.91.02v6.69c2.33.62 9.99.16 13.36-1.21l-1.05-1.27c1.24-.13 2.08-.15 3.37-.15 3.58 0 6.98.5 10.04 1.39v-7.1c-2.9-.72-6.55-1.42-10.04-1.42z'
        />
        <path
          className='choose1_svg__cls-8'
          d='M339.75 102.97c-2.34.24-3.98.62-5.64 1.11v1.97c-2.59.58-6.78 1.16-10.16.95-3.48-.22-7.98-1.48-9.92-2.22v-7.07c2.75 1.46 7.96 2.45 12.25 2.45 2.39 0 5.32-.31 7.05-.67l-.34-1.76c2.2-.75 3.56-1.39 6.76-1.71v6.95zM335.36 86.92c-2.44 0-6.01.56-7.01.84l1.16 1.87c-2.62.66-5.24.65-7.17.65-4.51 0-8.34-.95-12.32-2.47v7.08c3.06 1.04 6.99 1.85 10.71 1.85s7.81-.51 11.3-1.72l-.33-.86c1.21-.15 2.25-.23 3.58-.23 2.5 0 4.61.09 7.23.71v-7.1c-1.44-.32-4.72-.63-7.16-.63z'
        />
      </g>
      <g>
        <path
          className='choose1_svg__cls-7'
          d='M520.85 92.1h2v2h-2zM517.85 92.1h2v2h-2zM531.85 96.1H514.1l2.75 3v-1h17v-5h-2v3zM517.85 107.1h12v2h-12z'
        />
        <path className='choose1_svg__cls-7' d='M508.85 83.1v32h30v-32h-30zm2 30v-28h26v28h-26z' />
        <path
          className='choose1_svg__cls-7'
          d='M515.85 90.1h17.75l-2.75-3v1h-17v5h2v-3zM523.85 92.1h2v2h-2zM526.85 92.1h2v2h-2z'
        />
      </g>
      <g>
        <path
          className='choose1_svg__cls-7'
          d='M141.82 119.09v-2.03l-1.75-.48c-3.81-1.06-8.12-3.1-12.81-6.08l-.57-.36-.57.36c-4.98 3.19-8.84 5.07-12.54 6.09l-1.75.48v1.98c-.13 7.33 1.61 13.29 4.9 16.77 3.47 3.68 6.15 5.65 9.56 7.04l.38.14.4-.15c3.83-1.56 7.26-3.93 10.19-7.04 3.12-3.3 4.7-9.08 4.56-16.72zm-5.6 15.74c-2.76 2.93-5.98 5.16-9.55 6.64-3.12-1.29-5.62-3.16-8.9-6.63-3.03-3.21-4.64-8.8-4.51-15.74v-.95l.7-.19c3.79-1.05 7.72-2.95 12.72-6.14 4.73 2.98 9.1 5.04 12.99 6.12l.7.19v.96c.13 7.27-1.31 12.71-4.17 15.73z'
        />
        <path
          className='choose1_svg__cls-7'
          d='M126.92 117.43c-3.16 0-5.71 2.56-5.71 5.71 0 1.4.5 2.68 1.34 3.67v8.09l4.43-3.26 4.14 3.41v-8.04a5.7 5.7 0 001.52-3.87c0-3.16-2.56-5.71-5.71-5.71zm0 1.43c2.37 0 4.29 1.92 4.29 4.29s-1.92 4.29-4.29 4.29-4.29-1.92-4.29-4.29 1.92-4.29 4.29-4.29zm.1 10.98l-3.05 2.25v-4.05c.86.52 1.87.83 2.95.83 1 0 1.95-.26 2.77-.72v3.89l-2.67-2.2z'
        />
        <path
          className='choose1_svg__cls-7'
          d='M126.92 126a2.86 2.86 0 10.001-5.719 2.86 2.86 0 00-.001 5.719zm0-4.29a1.43 1.43 0 110 2.86 1.43 1.43 0 010-2.86z'
        />
      </g>
      <g>
        <path
          className='choose1_svg__cls-7'
          d='M527.06 183.56c-4.7 1.86-9.21-1.43-9.21-5.72v-2.75h2v2.64c0 1.93 1.05 3.91 2.91 4.46 3.09.91 6.09-1.08 6.09-4.34v-8.75h2v8.63c0 2.52-1.44 4.91-3.79 5.84z'
        />
        <path
          className='choose1_svg__cls-7'
          d='M535.6 173.1h-2.75v-2h2.64c1.93 0 3.75-1.17 4.36-3 1-3-.99-6-4.25-6h-8.75v-2h8.63c2.52 0 4.91 1.44 5.84 3.79 1.86 4.7-1.43 9.21-5.72 9.21zM522.85 173.1h-8.63c-2.52 0-4.91-1.44-5.84-3.79-1.86-4.7 1.43-9.21 5.72-9.21h2.75v2h-2.64c-1.93 0-3.91 1.05-4.46 2.91-.91 3.09 1.08 6.09 4.34 6.09h8.75v2z'
        />
        <path
          className='choose1_svg__cls-7'
          d='M519.85 165.1h-2v-8.63c0-2.52 1.44-4.91 3.79-5.84 4.7-1.86 9.21 1.43 9.21 5.72v2.75h-2v-2.64c0-1.93-1-3.36-3-4.36s-6 .99-6 4.25v8.75z'
        />
      </g>
    </g>
  </svg>
)
export default SvgChoose1
